<template>
  <v-dialog v-model="internalIsOpen" max-width="400px">
    <v-card>
      <v-card-title>Atención</v-card-title>
      <v-card-text class="bg-surface-light pt-4">
        {{ description }}
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="closeModal">Cerrar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    isOpen: Boolean,
    description: String
  },
  data() {
    return {
      internalIsOpen: this.isOpen
    }
  },
  watch: {
    isOpen(val) {
      this.internalIsOpen = val;
    },
    internalIsOpen(val) {
      this.$emit('update:isOpen', val);
    }
  },
  methods: {
    closeModal() {
      this.internalIsOpen = false;
    }
  }
}
</script>